export default Object.freeze({
  Python: 1,
});
